import { isAuth } from "actions";

const IsLogged = ({ children }) => {
  if (isAuth()) {
    return (window.location.href = "/");
  } else {
    return children;
  }
};

export default IsLogged;
